<template>
    <div class="falling-cards relative lg:static lg:h-full standalone:relative standalone:h-full">
        <div class="grid grid-cols-10 transform w-full h-full absolute inset-0">
            <template v-if="cellHeight > 0">
                <falling-card
                    v-for="(card, index) in cards"
                    :key="card.id"
                    :label="card.label"
                    :index="index"
                    :total="total"
                    :animate="animate"
                    :per-row="perRow"
                    :is-safari="isSafari"
                    :cell-height="cellHeight"
                />
            </template>
        </div>
    </div>
</template>

<script>
import shuffle from 'lodash/shuffle';
import FallingCard from '@/components/FallingCard';

export default {
    data() {
        return {
            total: 30,
            perRow: 10,
            animate: false,
            cellHeight: 0,
        };
    },
    components: {
        FallingCard,
    },
    computed: {
        cards() {
            return shuffle(Object.values(window.ratT.cards)).slice(
                0,
                this.total,
            );
        },
        isSafari() {
            return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        },
    },
    mounted() {
        this.animate =
            parseInt(
                getComputedStyle(document.documentElement).getPropertyValue(
                    '--motionOn',
                ),
                10,
            ) === 1;

        console.log('defeintely mounted tho');

        const totalRows = this.total / this.perRow;
        this.cellHeight = this.$el.getBoundingClientRect().height / totalRows;
    },
};
</script>
